import { emptyArray } from 'Lib/constants/placeholder';

import { Pages } from './constants';
import type { OnboardingState } from './types';

const DEFAULT_PAGES_QUEUE: Pages[] = [Pages.LOCATION_SCREEN, Pages.NOTIFICATIONS_SCREEN];
const initialState: OnboardingState = {
  completedPages: emptyArray,
  didSkipOnboarding: false,
  onboardingOpen: true,
  pagesQueue: DEFAULT_PAGES_QUEUE,
  swipeDemoShown: false,
};

export default initialState;
